import { DEFAULT_CALENDAR_STRINGS } from '../../utils';
export const defaultCalendarStrings = DEFAULT_CALENDAR_STRINGS;
